var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultipleBespoke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5068 7.13257L7.69676 14.2753C7.60645 14.3863 7.54102 14.5155 7.5049 14.6539L7.04399 16.4211C6.82999 17.2416 7.67012 17.9393 8.43736 17.5783L10.0928 16.7994C10.2256 16.7369 10.3431 16.6459 10.4368 16.5329L16.2207 9.55801M13.5068 7.13257L14.1242 6.37358C14.4816 5.93422 15.1321 5.87906 15.5584 6.25197L16.7981 7.33651C17.206 7.69337 17.2554 8.31023 16.9094 8.72744L16.2207 9.55801M13.5068 7.13257L16.2207 9.55801",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 22V2C1 1.44772 1.44772 1 2 1H22C22.5523 1 23 1.44772 23 2V22C23 22.5523 22.5523 23 22 23H2C1.44772 23 1 22.5523 1 22Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleBespoke);
export default __webpack_public_path__ + "static/media/multiple_bespoke.941f765400f279adb50f70ea2e4ff887.svg";
export { ForwardRef as ReactComponent };